var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { default as DayPickerInput } from 'react-day-picker/DayPickerInput';
import { formatDate, parseDate } from 'react-day-picker/moment';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import { translate } from 'react-i18next';
import { Button } from '@bytebrand/fe-ui-core-autobahn/ui';
import ContactBlocks from '../../ui/ContactBlocks/ContactBlocks';
import ExpansionPanel from '../../ui/ExpansionPanel/ExpansionPanel';
import DeleteV1Icon from '../../ui/SVG/DeleteV1Icon';
import { MONTHS } from '../../../framework/constants/app';
import { formatTimestamp } from '@bytebrand/fe-ui-core-autobahn/utils';
import styles from './CarsOnline.styl';
import Page from '../../containers/Page';
let CarsOnline = class CarsOnline extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "getCarsEntries", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { startDate, endDate } = this.state;
                const unixStartDate = +formatTimestamp({ timestamp: startDate, format: 'X' });
                const unixEndDate = +formatTimestamp({ timestamp: endDate, format: 'X' });
                this.props.carsStore.getOnlineCars(unixStartDate, unixEndDate);
            }
        });
        Object.defineProperty(this, "handleStartDayChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (day) => {
                this.setState({ startDate: formatTimestamp({ timestamp: day, format: 'YYYY-MM-DD' }) });
            }
        });
        Object.defineProperty(this, "handleEndDayChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (day) => {
                this.setState({ endDate: formatTimestamp({ timestamp: day, format: 'YYYY-MM-DD' }) });
            }
        });
        Object.defineProperty(this, "onSearchButtonClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.setState({ isUserInSearch: true });
                this.getCarsEntries();
            }
        });
        Object.defineProperty(this, "onNewSearch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.setState({ isUserInSearch: false });
            }
        });
        Object.defineProperty(this, "closeSearch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const newStartDate = moment().startOf('month').format('YYYY-MM-DD');
                const newEndDate = moment().endOf('month').format('YYYY-MM-DD');
                this.setState({
                    isUserInSearch: false,
                    startDate: newStartDate,
                    endDate: newEndDate
                }, () => {
                    this.getCarsEntries();
                });
            }
        });
        Object.defineProperty(this, "renderDatePickerHeader", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                let dateFormat = 'YYYY-MM-DD';
                const { t } = this.props;
                const { language } = this.props.appStore;
                if (language === 'de') {
                    dateFormat = 'DD-MM-YYYY';
                }
                return (React.createElement("div", { className: styles.search },
                    React.createElement("div", { className: styles.emptySearchForNow }, "hidden"),
                    React.createElement("span", { className: styles.searchText }, t('searchFrom')),
                    React.createElement(DayPickerInput, { dayPickerProps: {
                            locale: language,
                            months: MONTHS[language],
                            firstDayOfWeek: 1
                        }, formatDate: formatDate, parseDate: parseDate, placeholder: `${formatDate(this.state.startDate, dateFormat, language)}`, onDayChange: this.handleStartDayChange, value: `${formatDate(this.state.startDate, dateFormat, language)}`, format: dateFormat }),
                    React.createElement("span", { className: styles.searchText }, t('searchTo')),
                    React.createElement(DayPickerInput, { dayPickerProps: {
                            locale: language,
                            months: MONTHS[language],
                            firstDayOfWeek: 1
                        }, formatDate: formatDate, parseDate: parseDate, placeholder: `${formatDate(this.state.startDate, dateFormat, language)}`, onDayChange: this.handleEndDayChange, value: `${formatDate(this.state.startDate, dateFormat, language)}`, format: dateFormat }),
                    React.createElement(Button, { variant: 'filled', className: styles.searchButton, onClick: this.onSearchButtonClick }, t('searchButton'))));
            }
        });
        Object.defineProperty(this, "renderExpansionPanelTitle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (text) => (React.createElement("span", { className: styles.expansionPanelTitle }, text))
        });
        Object.defineProperty(this, "renderRowTitle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => (React.createElement("div", { className: styles.rowTitle },
                React.createElement("span", { className: styles.rowTitleText }, this.props.t('addedAt')),
                React.createElement("span", { className: styles.rowTitleText }, this.props.t('internalNumber')),
                React.createElement("span", { className: styles.rowTitleText }, this.props.t('marke')),
                React.createElement("span", { className: styles.rowTitleText }, this.props.t('model')),
                React.createElement("span", { className: styles.rowTitleText }, this.props.t('farbe')),
                React.createElement("span", { className: styles.rowTitleText }, this.props.t('linkToAuto'))))
        });
        Object.defineProperty(this, "renderRowData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id, internalNumber, date, make, model, color) => (React.createElement("div", { className: styles.rowData, key: id },
                React.createElement("span", { className: styles.rowTitleText },
                    formatTimestamp({ timestamp: date, format: 'hh:mm', parseFormat: 'X' }),
                    " ",
                    this.props.t('oclock')),
                React.createElement("span", { className: styles.rowTitleText }, internalNumber),
                React.createElement("span", { className: styles.rowTitleTextCapitalized }, make),
                React.createElement("span", { className: styles.rowTitleTextCapitalized }, model),
                React.createElement("span", { className: styles.rowTitleText }, this.props.t(`cbd:${color}`)),
                React.createElement(Link, { className: styles.rowTitleText, target: '_blank', to: { pathname: `/my-vehicles/${id}` } }, this.props.t('details'))))
        });
        Object.defineProperty(this, "renderActiveSearchHeader", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { t } = this.props;
                return (React.createElement("div", { className: styles.activeSearchHeader },
                    React.createElement("span", { className: styles.searchPeriodSpan },
                        React.createElement("b", null, t('searchPeriod')),
                        ": ",
                        this.state.startDate,
                        " - ",
                        this.state.endDate),
                    React.createElement("div", { className: styles.activeSearchButtons },
                        React.createElement(Button, { variant: 'filled', className: styles.searchButton, onClick: this.onNewSearch }, t('newSearch')),
                        React.createElement("span", { className: styles.resetSearchButton, onClick: this.closeSearch },
                            React.createElement(DeleteV1Icon, null)))));
            }
        });
        Object.defineProperty(this, "renderSearchResultsText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (resultCount) => {
                const { t } = this.props;
                return (React.createElement("p", { className: styles.searchResultsText }, t('searchResultText', { count: resultCount })));
            }
        });
        Object.defineProperty(this, "renderOnlineList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (jsOnlineCars, onlineCarsLength) => {
                const { t } = this.props;
                return (React.createElement("div", { className: styles.calculationContainer },
                    this.state.isUserInSearch ? this.renderActiveSearchHeader() : this.renderDatePickerHeader(),
                    this.state.isUserInSearch ? this.renderSearchResultsText(onlineCarsLength) : null,
                    onlineCarsLength ? Object.keys(jsOnlineCars).map((key) => (React.createElement(ExpansionPanel, { title: this.renderExpansionPanelTitle(formatTimestamp({ timestamp: key, format: 'DD MMMM YYYY', parseFormat: 'DD.MM.YYYY' })), subTitle: t('carEntry', { count: jsOnlineCars[key].length }), className: styles.expansionPanel, headerClassName: styles.headerClassName, bodyClassName: styles.bodyClassName, subTitleClassName: styles.subTitleClassName, key: key },
                        this.renderRowTitle(),
                        jsOnlineCars[key].map((value) => this.renderRowData(value._id, value.offer.internalNumber, value.state.firstIsOnline, value.mainData.make, value.mainData.model, value.exterior.exteriorColor))))) : null));
            }
        });
        this.state = {
            isUserInSearch: false,
            startDate: moment().startOf('month').format('YYYY-MM-DD'),
            endDate: moment().endOf('month').format('YYYY-MM-DD')
        };
    }
    componentDidMount() {
        this.getCarsEntries();
    }
    componentWillUnmount() {
        this.props.carsStore.clearCars();
    }
    render() {
        const { t, carsStore } = this.props;
        const jsOnlineCars = toJS(carsStore.onlineCars);
        const { onlineCarsLength } = carsStore;
        return (React.createElement(Page, { page: 'CARS_ONLINE' },
            React.createElement("div", { className: 'md3 carsOnlinePage' },
                React.createElement("div", { className: styles.header },
                    React.createElement("span", { className: styles.headerTitle }, t('headerTitle'))),
                React.createElement(ContactBlocks, { t: t }),
                React.createElement("p", { className: styles.allPricesText }, t('allPrices')),
                React.createElement("div", { className: styles.calculationContainer },
                    this.state.isUserInSearch ? this.renderActiveSearchHeader() : this.renderDatePickerHeader(),
                    this.state.isUserInSearch ? this.renderSearchResultsText(onlineCarsLength) : null,
                    onlineCarsLength ? Object.keys(jsOnlineCars).map((key) => (React.createElement(ExpansionPanel, { title: this.renderExpansionPanelTitle(formatTimestamp({ timestamp: key, format: 'DD MMMM YYYY', parseFormat: 'DD.MM.YYYY' })), subTitle: t('carEntry', { count: jsOnlineCars[key].length }), className: styles.expansionPanel, headerClassName: styles.headerClassName, bodyClassName: styles.bodyClassName, subTitleClassName: styles.subTitleClassName, key: key },
                        this.renderRowTitle(),
                        jsOnlineCars[key].map((value) => this.renderRowData(value._id, value.offer.internalNumber, value.state.firstIsOnline, value.mainData.make, value.mainData.model, value.exterior.exteriorColor))))) : null))));
    }
};
CarsOnline = __decorate([
    inject('carsStore', 'appStore'),
    observer,
    __metadata("design:paramtypes", [Object])
], CarsOnline);
export default translate(['CarsOnlinePage'])(CarsOnline);
